import Input from './Input'
import MarginOptions from './MarginOptions'
import RightBarGroup from './RightBarGroup'
import Select from './Select'
import ImageOptions from './ImageOptions'
import {
  ChangeEvent,
  DynamicContentType,
  FileEntryBM,
  ImageCollageData,
} from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<ImageCollageData>
  setData: (e: ChangeEvent<string | FileEntryBM | undefined>) => void
}

const ImageCollageEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()
  return (
    <>
      <Input
        light
        type='image'
        value={content.data.mainImage}
        label={tr(TrKey.imageCollageEditorMainImage)}
        setter={(f) => setData({ target: { name: 'mainImage', value: f } })}
      />
      <Input
        light
        type='image'
        value={content.data.secondaryImage}
        label={tr(TrKey.imageCollageEditorSecondaryImage)}
        setter={(f) =>
          setData({ target: { name: 'secondaryImage', value: f } })
        }
      />
      <RightBarGroup title={tr(TrKey.imageCollageEditorSettingsTitle)} topLine>
        <Select
          label={tr(TrKey.imageCollageEditorLayoutLabel)}
          desc={tr(TrKey.imageCollageEditorLayoutDescription)}
          id='layout'
          light
          name='layout'
          value={content.data.layout}
          onChange={setData}
        >
          <option value='bottomLeft'>
            {tr(TrKey.imageCollageEditorLayoutOptionBottomLeft)}
          </option>
          <option value='bottomRight'>
            {tr(TrKey.imageCollageEditorLayoutOptionBottomRight)}
          </option>
        </Select>
        <ImageOptions content={content} setData={setData} />
      </RightBarGroup>
      <MarginOptions content={content} setData={setData} />
    </>
  )
}

export default ImageCollageEditor
